<div class="background-container">
    <div class="background-content">
        <div class="top-left-element"></div>
        <div class="bottom-right-element"></div>
    </div>
</div>
